import React from 'react';
import PropTypes from 'prop-types';
// import classnames from 'classnames';


import '../../App.css';
import '../../styles/contactUs.css'

const ContactTextInput = ({
  label,
  name,
  value,
  // placeholder,
  type,
  onChange, 
  error
}) => {
  return (
    <div className="input-data">
      <input 
        type={type}
        name={name}
        // className={classnames('form-control form-control-lg', {
        //     'is-invalid': error
        // })}
        // placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
      <div className="underline"></div>
      <label htmlFor={name}>{label} </label>
      {error && <div className="invalid-feedback">
        {error}</div>
      }
    </div>
  );
};

ContactTextInput.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  // placeholder: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string
}

ContactTextInput.defaultProps = {
  type: 'text'
}

export default ContactTextInput;